import { readApiJson } from '../lib/api';

const STORAGE_KEY = 'cbat_announcement_events';
const MAX_REMEMBERED = 200;

const reported = new Set();

const readRemembered = () => {
  try {
    const stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(stored) ? stored : [];
  } catch (error) {
    return [];
  }
};

const writeRemembered = (keys) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(keys.slice(-MAX_REMEMBERED)));
  } catch (error) {
    // Without storage it is asked again the next time the page loads, which is harmless.
  }
};

// Tells the server that this person has seen an announcement ('seen') or
// clicked its link ('click'), for the counts on the administrator's list. The
// server counts a person once however often this is sent, so remembering what
// was reported only saves asking again on every page. One that fails is
// forgotten, to be tried again on a later visit.
export const reportAnnouncementEvent = (userId, announcementId, event) => {
  if (!userId || !announcementId) return;
  const key = `${userId}:${announcementId}:${event}`;
  if (reported.has(key)) return;
  reported.add(key);

  const remembered = readRemembered();
  if (remembered.includes(key)) return;
  writeRemembered([...remembered, key]);

  readApiJson(`/announcements/${announcementId}/${event}`, { method: 'POST' }).catch(() => {
    reported.delete(key);
    writeRemembered(readRemembered().filter((item) => item !== key));
  });
};
